import { immerable } from '@topwrite/common';
import mime from 'mime/lite';
import path from 'path';
import { socket } from '../lib/socket';

export default class File {

    [immerable] = true;

    path: string;
    content: Buffer;
    ctime: string;

    constructor(path: string, content: Buffer) {
        this.path = path;
        this.content = content;
        this.ctime = new Date().toISOString();
    }

    get mime(): string {
        return mime.getType(this.path) || 'application/octet-stream';
    }

    relative(to: string) {
        const isDirectory = to.slice(-1) === '/';

        to = path.posix.relative(
            path.posix.dirname(this.path),
            to
        ) || '.';

        return to + (isDirectory ? '/' : '');
    }

    resolve(to: string) {
        if (path.isAbsolute(to)) {
            return to.slice(1);
        }
        return path.posix.join(path.posix.dirname(this.path), to);
    }

    static async createFromSocket(path: string) {
        const buf = await socket.readFile(path);
        return new File(path, buf);
    }
}
